import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class RightMenuService {
  public opened = !(window.innerWidth <= 700);
  private openedStateChanged$ = new BehaviorSubject<boolean>(this.opened);
  constructor(private baseService: BaseService) { }

  public toggle() {
    this.opened = !this.opened;
    this.openedStateChanged$.next(this.opened);
  }

}
